import {Dialog, DialogContent, DialogContentText} from "@mui/material";
import { useAppContext } from "../../../../AppContext";
import ConnectedServicesList from "../../ConnectedServicesList";
import useExternalService from "../../hooks/useExternalService";
import styled from "@emotion/styled";
import {Button} from "../../../../ui/Button/Button";
import GrayButton from "../GrayButton";
import {useState} from "react";

export type ConnectedServicesProps = {
  services?: string[];
  shortToken?: string;
  isLoading?: boolean;
  onServiceItemConnect?: () => void;
  onServiceItemDisconnect?: () => void;
}

export const ConnectedServices = (props: ConnectedServicesProps) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [service, setService] = useState('');
  
  const {
    store: { authStore },
    api: { settingsApi, authApi },
  } = useAppContext();
  const [openOAuthWindow] = useExternalService(settingsApi);

  const onServiceItemConnect = async (service: string) => {
    if (props.onServiceItemConnect) {
      props.onServiceItemConnect();
    }
    
    const shortToken = props.shortToken ? {data: props.shortToken} : await authApi.getShortToken();
    if (shortToken?.data) {
      openOAuthWindow(service, shortToken.data);
      return;
    }
  };

  const onServiceDisconnect = (service: string) => {
    setService(service);
    setShowConfirmDialog(true);
  }
  
  const onConfirm = async (service: string) => {
    setShowConfirmDialog(false);
    if (props.onServiceItemDisconnect) {
      props.onServiceItemDisconnect();
    }
    
    await settingsApi.removeExternalService(service, props.shortToken);
    authStore.removeService(service);
  }
  
  const onCancel = () => {
    setService(service);
    setShowConfirmDialog(false);
  }

  return (
    <>
      <ConnectedServicesList
        isLoading={props.isLoading}
        services={props.services}
        onConnect={onServiceItemConnect}
        onDisconnect={onServiceDisconnect}
      />
      {showConfirmDialog && <Dialog
        fullWidth
        maxWidth={'xs'}
        hideBackdrop
        open
        PaperProps={{
          sx: {
            background: '#fff',
            elevation: 38,
            boxShadow: '1',
            maxWidth: '250px',
          },
        }}
      >
        <DialogContent>
          <DialogContentText>
            <STitle>
              Отключить {service}
            </STitle>
            <STextContent>
              Данные о тренировках {service} больше не будут синхронизироваться с YNA?
            </STextContent>
            <SButtonWrapper>
              <Button onClick={onCancel}>Отмена</Button>
              <GrayButton onClick={() => onConfirm(service)}>Отключить</GrayButton>
            </SButtonWrapper>
          </DialogContentText>
        </DialogContent>
      </Dialog>}
    </>
  );
};

const STitle = styled.div`
    color: #1A222D;
    text-align: center;
    font-variant-numeric: lining-nums tabular-nums;
    padding-top: 4px;

    font-family: "Golos Text";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

const STextContent = styled.div`
    color: #97A4B7;
    text-align: center;

    font-family: "Golos Text";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 18.2px */
    padding: 18px 0;
`;

const SButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    *:first-child {
        margin-right: 24px;
    }
`;